<table mat-table [dataSource]="pagedResults()" [trackBy]="trackByItemId">
    <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef>Rank</th>
        <td mat-cell *matCellDef="let item">{{ item.rankLabel }}</td>
    </ng-container>

    <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>Selection</th>
        <td mat-cell *matCellDef="let item">{{ item.label }}</td>
    </ng-container>

    <ng-container matColumnDef="votes">
        <th mat-header-cell *matHeaderCellDef>Votes</th>
        <td mat-cell *matCellDef="let item">
            <div class="votes-cell">
                <span class="votes-count">{{ item.count | number }}</span>
                <mat-progress-bar
                    mode="determinate"
                    [value]="item.percentage"
                />
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="is-write-in">
        <th mat-header-cell *matHeaderCellDef>Write-In</th>
        <td mat-cell *matCellDef="let item">
            <span class="write-in-pill" [class.is-write-in]="item.isWriteIn">
                {{ item.isWriteIn ? "Yes" : "No" }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="percentage">
        <th mat-header-cell *matHeaderCellDef>% of Total Votes</th>
        <td mat-cell *matCellDef="let item">
            {{ item.percentage | number: "1.1-1" }}%
        </td>
    </ng-container>

    <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns(); sticky: true"></tr>
    <!-- `data-item-id` is a stable per-row key for FLIP row-reorder animations in the host view
         (see host-poll.component.ts). Inert for callers that don't animate. -->
    <tr
        mat-row
        *matRowDef="let row; columns: tableColumns()"
        [attr.data-item-id]="row.itemId"
    ></tr>
    <tr class="no-filter-results" *matNoDataRow>
        <td [attr.colspan]="tableColumns().length">
            <h4>No Results</h4>
            @if (searchQuery(); as query) {
                <p>
                    No matches found for
                    <strong>[{{ query }}]</strong>
                </p>
                <p>Please check the spelling or try another search.</p>
            }
        </td>
    </tr>

    <!-- The row/column def itself is always registered rather than added/removed via @if:
         CdkTable only re-renders the footer outlet when its row-def diffing detects a change, and
         that diff is a reduce over the *current* footer defs — once showFooter() flips to false and
         this was the only def, the list goes from one entry to zero and there's nothing left to
         diff, so the previously-rendered row is never cleared. Keeping the def registered and
         toggling a class on the row sidesteps that CdkTable limitation. The paginator/select inside
         stay conditional so they're not needlessly instantiated while hidden. -->
    <ng-container matColumnDef="footer">
        <td
            mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="tableColumns().length"
        >
            @if (showFooter()) {
                <div class="table-footer">
                    <tools-paginator
                        [length]="filteredResults().length"
                        [pageSize]="pageSize()"
                        [pageIndex]="clampedPageIndex()"
                        [pageSizeOptions]="pageSizeOptions"
                        (page)="onPageChange($event)"
                    />
                    <mat-form-field appearance="outline" class="page-size">
                        <mat-label>Rows per page</mat-label>
                        <mat-select
                            [value]="pageSize()"
                            (selectionChange)="onPageSizeChange($event.value)"
                        >
                            @for (size of pageSizeOptions; track size) {
                                <mat-option [value]="size">
                                    {{ size }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (showTotalSelectionsInFooter()) {
                        <span class="body-2">
                            {{ filteredResults().length | number }} selections
                        </span>
                    }
                </div>
            }
        </td>
    </ng-container>
    <tr
        mat-footer-row
        *matFooterRowDef="['footer']; sticky: true"
        [class.hidden]="!showFooter()"
    ></tr>
</table>
